import { Image, Link, Box, List, SimpleGrid, VisuallyHidden } from '@chakra-ui/react';
import { CornerRightUp } from 'lucide-react';

import ImpactReportLayout from '../../../../components/layouts/impactreport';
import ImpactReporth2 from '../../../../components/sections/impactreport/impact-h2';
import ImpactReporth4 from '../../../../components/sections/impactreport/impact-h4';
import ImpactReporth5 from '../../../../components/sections/impactreport/impact-h5';
import TableOfContents from '../../../../components/sections/tableofcontents';
import ImpactReportPrevNextNav from '../../../../components/sections/impactreport/prev-next-nav';

import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import BrandLockup from '../../../../components/sections/brandlockup';
import homeVideo from '../../../../components/ui/corporateresponsibility/impact/2024-impact-report/about/2024_impact_report_bkg.mp4';

// Brand images
import columbiaLogo from '../../../../components/ui/brandlogos/columbia_logo_black.png';
import sorelLogo from '../../../../components/ui/brandlogos/SOREL_logo_black.png';
import mhwLogo from '../../../../components/ui/brandlogos/mhw_logo_black.png';
import pranaLogo from '../../../../components/ui/brandlogos/prAna_logo_black.png';

import scopeBkgImg from '../../../../components/ui/corporateresponsibility/impact/2024-impact-report/about/scope_and_scale_bkg.jpg';
import ourBrandsBkgImg from '../../../../components/ui/corporateresponsibility/impact/2024-impact-report/about/our_brands_bkg.jpg';
import valuesBkgImg from '../../../../components/ui/corporateresponsibility/impact/2024-impact-report/about/core-values-bkg_2.jpg';

import competeToWinBkgImg from '../../../../components/ui/corporateresponsibility/impact/2024-impact-report/about/compete-to-win.jpg';
import activeLifestyleBkgImg from '../../../../components/ui/corporateresponsibility/impact/2024-impact-report/about/active-lifesstyle.jpg';
import relentlessImpovementBkgImg from '../../../../components/ui/corporateresponsibility/impact/2024-impact-report/about/relentless-improvement.jpg';
import honestyRespectTrustBkgImg from '../../../../components/ui/corporateresponsibility/impact/2024-impact-report/about/honesty-respect-trust.jpg';
import doingTheRightThingBkgImg from '../../../../components/ui/corporateresponsibility/impact/2024-impact-report/about/doing-the-right-thing.jpg';

// Highlights
import empoweringPeopleImg from '../../../../components/ui/corporateresponsibility/impact/2024-impact-report/about/empowering_people_highlights.jpg';
import sustainingPlacesImg from '../../../../components/ui/corporateresponsibility/impact/2024-impact-report/about/sustaining_places_highlights_1.jpg';
import responsiblePracticesImg from '../../../../components/ui/corporateresponsibility/impact/2024-impact-report/about/responsible_practices_highlights.jpg';


// Partnerships
import PartnershipImages from '../../../../components/ui/corporateresponsibility/impact/2024-impact-report/about/partnerships';

export default function TwentyTwentyFourImpactReport() {

    const links = [
        {
            title: "About Us and 2024 Highlights",
            active: true
        },
        {
            title: "Empowering People",
            href: "/corporate-responsibility/impact/2024/empowering-people",
            active: false
        },
        {
            title: "Sustaining Places",
            href: "/corporate-responsibility/impact/2024/sustaining-places",
            active: false
        },
        {
            title: "Responsible Practices",
            href: "/corporate-responsibility/impact/2024/responsible-practices",
            active: false
        },
        {
            title: "Appendices",
            href: "/corporate-responsibility/impact/2024/appendices",
            active: false
        }
    ];

    const ReportNav = () => {
        return ( 
        <>
            <div>
                <nav id='main-report-nav'>
                    <ul className='nav-list'>
                        {links.map(link => (
                            link.active === false ? (
                            <li key={link.title}>
                                <Link href={link.href} className='nav-link'>
                                    <span className='nav-link__text'>{link.title}</span>
                                </Link>
                            </li>
                            ) :
                            (
                                <li className='active' key={link.title}>
                                    <span className='nav-link__text'>{link.title}</span>
                                    <TableOfContents />
                                </li>
                            )
                        )
                        )}
                    </ul>
                </nav>
            </div>
        </>
        );
      }

    const Hero = () => {
        return(<>
            <div className='hero-main height-100'>
                <div className='hero-main__container'>
                    <div className='hero-main__inner-container'>
                        <div className='hero-main__inner center-left is-top'>
                        <div className='container'>
                            <div className='hero-main__content'>
                                <h1 style={{ fontSize: 'var(--step-6)' }}>2024<br /> Impact Report</h1>
                                <BrandLockup />
                            </div>
                        </div>
                        </div>
                        <div className='hero-main__video-container'>
                        <video
                            width='100%'
                            height='100%'
                            loop
                            muted
                            autoPlay
                            playsInline
                        >
                            <source src={homeVideo} type='video/mp4'></source>
                        </video>
                        </div>
                        <div className='hero-main__caret-wrapper'>
                        <figure className='hero-main__caret'>
                            <KeyboardArrowDownOutlinedIcon />
                        </figure>
                        </div>
                        <div className='hero-main__overlay'></div>
                    </div>
                </div>
            </div>
        
        </>)
    }
    
    return (
        <ImpactReportLayout
            reportTitle="2024 Impact Report"
            sidebar={<ReportNav />}
            reporthero={<Hero />}
            pdfUrl="/pdfs/2024-impact-report.pdf"
        >
            <title>2024 Impact Report</title>
            <meta name="description" content="Columbia Sportswear Company's Impact Report demonstrates our commitment to ensuring the sustainability of our business and the planet." />

            <div className='our-mission'>
                <div className='container'>
                    <div className='our-mission__subheading'>
                        <h2>Our Mission</h2>
                    </div>
                    <div className='our-mission__content'>
                        <p>We Connect<br />Active People With<br />Their Passions</p>
                    </div>
                </div>
            </div>

            <div className='our-values' style={{ backgroundImage: `url(${valuesBkgImg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center', '--flow-space': '0' }}>
                <div className='container'>
                    <ImpactReporth2>Our Core Values</ImpactReporth2>
                </div>
                
                <div className='core-values'>
                    <div className='core-values__item item-one' style={{ backgroundImage: `linear-gradient(0deg,rgba(0, 0, 0, .4),rgba(0, 0, 0, .2)),url(${activeLifestyleBkgImg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        <p>Enjoy an Active<br />Lifestyle</p>
                    </div>
                    <div className='core-values__item item-two' style={{ backgroundImage: `linear-gradient(0deg,rgba(0, 0, 0, .4),rgba(0, 0, 0, .2)),url(${competeToWinBkgImg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        <p>Compete<br />to Win</p>
                    </div>
                    <div className='core-values__item item-three' style={{ backgroundImage: `linear-gradient(0deg,rgba(0, 0, 0, .4),rgba(0, 0, 0, .2)),url(${relentlessImpovementBkgImg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        <p>Relentless<br />Improvement</p>
                    </div>
                    <div className='core-values__item item-four' style={{ backgroundImage: `linear-gradient(0deg,rgba(0, 0, 0, .4),rgba(0, 0, 0, .2)),url(${honestyRespectTrustBkgImg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        <p>Culture of<br />Honesty, Respect,<br />& Trust</p>
                    </div>
                    <div className='core-values__item item-five' style={{ backgroundImage: `linear-gradient(0deg,rgba(0, 0, 0, .4),rgba(0, 0, 0, .2)),url(${doingTheRightThingBkgImg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        <p>Doing the<br />Right Thing</p>
                    </div>
                </div>
            </div>

            <div className='our-brands' style={{ backgroundImage: `linear-gradient(0deg,rgba(255, 255, 255, 1),rgba(255, 255, 255, 0.8),rgba(255, 255, 255, 0.6),rgba(255, 255, 255, 0.4),rgba(255, 255, 255, 0.2)) ,url(${ourBrandsBkgImg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center', '--flow-space': '0' }}>
                <div className='container'>
                    <ImpactReporth2>Our Brands</ImpactReporth2>
                </div>

                <div className='container'>
                    <div className='impact-report-brands'>
                        <div className='impact-report-brands__item'>
                            <img id='impact-report__columbia' src={columbiaLogo} alt='Columbia Sportswear logo' />
                            <p>Founded in 1938, our Columbia brand's mission is to unlock the outdoors for everyone. The Columbia brand offers authentic, high-value outdoor apparel, footwear, accessories and equipment products suited for hiking, trail running, snow, and fishing and hunting activities, as well as everyday outdoor activities.</p>
                            <div className='divider' />
                        </div>
                        <div className='impact-report-brands__item'>
                            <img id='impact-report__sorel' src={sorelLogo} alt='SOREL logo' />
                            <p>Acquired in 2000, our SOREL brand has evolved from a men's utility boot brand into a contemporary lifestyle brand, bringing style to the outdoors. SOREL leverages its rich heritage, innovation and style to offer distinct, compelling, and unexpected footwear to consumers around the world.</p>
                            <div className='divider' />
                        </div>
                        <div className='impact-report-brands__item'>
                            <img id='impact-report__mhw' src={mhwLogo} alt='Mountain Hardwear logo' />
                            <p>Acquired in 2003, our Mountain Hardwear brand's mission is to encourage and equip people to seek a wilder path in life. With over 30 years of wild wisdom, Mountain Hardwear continues to offer essential, premium apparel, accessories and equipment products for climbers, mountaineers, skiers, snowboarders, and trail athletes.</p>
                            <div className='divider' />
                        </div>
                        <div className='impact-report-brands__item'>
                            <img id='impact-report__prana' src={pranaLogo} alt='prAna logo' />
                            <p>Acquired in 2014, our prAna brand's mission is to celebrate the spirit of adventure and discovery, encouraging individuals to pursue their passions inspired by an active California lifestyle. prAna offers apparel and accessories that blend style and versatility for individuals who embrace movement and have a deep reverence for nature.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='message-from-ceo'>
                <VisuallyHidden>
                    <div className='container'>
                        <ImpactReporth2>Message from Our CEO</ImpactReporth2>
                    </div>
                </VisuallyHidden>
                

                <div className='quote__content container'>
                    <div className='prose-content flow ceo-quote container'>
                        <blockquote>
                            “At Columbia Sportswear Company, we believe in making a positive impact in the communities we live, work and recreate. Guided by our value of "doing the right thing," we strive to ensure our actions benefit both people and the planet. This report highlights our work around Empowering People, Sustaining Places and Responsible Practices.”
                        </blockquote> 
                        <div className='signature'>
                            <p>Tim Boyle, Chairman, President & CEO</p>
                        </div>
                    </div>
                </div>
            </div>
            
            <section id='scope-and-scale' style={{ backgroundImage: `url(${scopeBkgImg})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className='container flow'>
                    <div className='non-nav-character'>
                        <ImpactReporth2>2024 Scope & Scale</ImpactReporth2><span className='header-addition'>*</span>
                    </div>
                        <table className='scope-and-scale' style={{ tableLayout: 'unset' }}>
                            <tbody>
                                <tr style={{borderBottom: '2px dotted black'}}>
                                    <td style={{borderRight: '2px dotted black'}}>
                                        <div>
                                            <span>4</span>
                                            <span>Primary<br />Brands</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <span>1938</span>
                                            <span>Founded in<br />Portland, Oregon</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr style={{borderBottom: '2px dotted black'}}>
                                    <td style={{borderRight: '2px dotted black'}}>
                                        <div>
                                            <span>9,700</span>
                                            <span>Full-time &<br />Part-time Employees</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <span>$3,369</span>
                                            <span>Million<br />Net Sales in 2024</span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{borderRight: '2px dotted black'}}>
                                        <div>
                                            <span>170+</span>
                                            <span>Directly Operated<br />U.S. Retail Stores</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            <span>110+</span>
                                            <span>Countries in Which<br />Product is Sold</span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p style={{ fontSize: 'var(--step--1)', fontWeight: 'bold', marginTop: 'var(--space-m)' }}>*As of December 31, 2024</p>
                    </div>
            </section>
            
            <section id='impact-governance-section'>
                <div className='container flow'>
                    <ImpactReporth2>Impact Governance</ImpactReporth2>
                    <p>
                        Our Board of Directors (the Board) shares in the oversight of our impact efforts. The Talent and Compensation Committee considers human capital management issues, while the Audit Committee reviews periodic reporting on environmental, social, and governance (ESG) matters. The Nominating and Corporate Governance Committee considers ESG issues, including potential long- and short-term trends and impacts on Columbia Sportswear Company’s (“CSC”) business. Each committee reports to the full Board with respect to their specific responsibilities. The Board is also informed of supply chain oversight and related risks. CSC management views ESG as a company-wide effort, with collaboration and commitment throughout the supply chain. For more information, please visit our <a href='https://investor.columbia.com/' rel='noreferrer noopener' target='_blank'>Investor Relations website</a> for our Board Committee Charters. In 2021, the Company created an ESG Steering Committee comprised of senior leaders in various different functions. 
                    </p>
                </div>
            </section>

            <section id='report-highlights-section'>
                <div className='container flow'>
                    <ImpactReporth2>2024 Highlights</ImpactReporth2>
                    <Box
                        marginTop={6}
                    >
                        <SimpleGrid
                            columns={{ base: 1, sm: 2, md: 3}}
                            gap={{ base : 8, md: 4 }}
                        >
                            <Box>
                                <Box 
                                    className='highlights-image'
                                    display={'flex'}
                                    justifyContent={'center'}
                                >
                                    <Image src={empoweringPeopleImg} borderRadius={'50%'} width={'75%'} />
                                </Box>
                                <Box 
                                    className='highlights-text'
                                    padding={4}
                                    mt={1}    
                                >
                                    <div>
                                        <ImpactReporth4>Empowering People</ImpactReporth4>
                                    </div>
                                    
                                    <List.Root mt={3} fontSize={'var(--step--1)'}>
                                        <List.Item>
                                            As of 2024, we’ve exceeded 80% of our Planet Water goal of providing access to clean water for 100,000 people per day.
                                        </List.Item>
                                        <List.Item>
                                            Employees contributed over 6,100 volunteer hours. 
                                        </List.Item>
                                        <List.Item>
                                            Mountain Hardwear was named Corporate Partner of the Year by Leave No Trace.
                                        </List.Item>
                                        <List.Item>
                                            The myWellbeing program reimbursed more than 1,300 unique requests for a variety of employee wellness activities.
                                        </List.Item>
                                    </List.Root>
                                </Box>
                            </Box>
                            <Box>
                                <Box 
                                    className='highlights-image'
                                    display={'flex'}
                                    justifyContent={'center'}
                                >
                                    <Image src={sustainingPlacesImg} borderRadius={'50%'} width={'75%'} />
                                </Box>
                                <Box 
                                    className='highlights-text'
                                    padding={4}    
                                >
                                    <div>
                                        <ImpactReporth4>Sustaining Places</ImpactReporth4>
                                    </div>
                                    <List.Root mt={3} fontSize={'var(--step--1)'}>
                                        <List.Item>
                                            Absolute energy consumption, 2022 versus 2024, at our Oregon distribution center and headquarters has declined by over 900,000 kilowatt hours and nearly 67,000 therms.<span className='fn-link' id="fn1"><a href="#fn1_content"><sup>1</sup></a></span>
                                        </List.Item>
                                        <List.Item>
                                            The Chinese Taipei office began a program to procure 100% Renewable Energy Certificates (RECs) to account for all grid energy consumption.
                                        </List.Item>
                                        <List.Item>
                                            Global corrugated outer cartons and inner boxes used for product packaging contained a minimum of 95% recycled content in 2024.
                                        </List.Item>
                                    </List.Root>
                                </Box>
                            </Box>
                            <Box>
                                <Box 
                                    className='highlights-image'
                                    display={'flex'}
                                    justifyContent={'center'}
                                >
                                    <Image src={responsiblePracticesImg} borderRadius={'50%'} width={'75%'} />
                                </Box>
                                <Box 
                                    className='highlights-text'
                                    padding={4}    
                                >
                                    <div>
                                        <ImpactReporth4>Responsible Practices</ImpactReporth4>
                                    </div>
                                    
                                    <List.Root mt={3} fontSize={'var(--step--1)'} >
                                        <List.Item>
                                            In July 2024, our internal Ethics & Compliance awareness month highlighted our Compliance Line to further encourage a speak-up culture.
                                        </List.Item>
                                        <List.Item>
                                            In partnership with all other RISE industry supporters in 2024, RISE reached over 425 workplaces, totaling more than 375,000 workers, over 65% of whom identify as women.
                                        </List.Item>
                                        <List.Item>
                                            In 2024, we worked with 330 finished good vendors, of which 87% completed at least one audit or assessment during the year.
                                        </List.Item>
                                    </List.Root>
                                </Box>
                            </Box>

                            </SimpleGrid>
                        </Box>
                </div>
            </section>
            
            <section id='partnerships-section'>
                <div className='container flow'>
                    <ImpactReporth2>Industry Partnerships & Memberships</ImpactReporth2>
                    <div className='partnership-grid'>
                        {PartnershipImages.map((image) => (
                            <div className='partnership-grid__item' key={image.id}>
                                <img src={image.src} id={image.name} alt='' />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section style={{ marginTop: 'var(--space-2xl)', '--spotlight-color': 'var(--csc-gray)' }} className='product-spotlight'>
                <div className='container flow'>
                    <ImpactReporth5>Troy Sicotte, Mountain Hardwear Brand President</ImpactReporth5>
                    <p>
                        “Being a member of the Outdoor Industry Association (OIA) Board of Directors allows me to positively contribute to the industry’s impact progress and mission to grow the benefits of the outdoors for everyone.”
                    </p>
                </div>
            </section>

            <ImpactReportPrevNextNav
                nextText="Empowering People"
                nextLink="/corporate-responsibility/impact/2024/empowering-people"
            />

            <section>
                <div className='container'>
                    <div className='footnotes'>
                        <hr />
                        <h6>Footnotes</h6>
                        <ol>
                            <li className='footnote' id='fn1_content'>
                                <span className='fn-text'>Absolute energy consumption is calculated as the sum of electricity and natural gas consumption at our Oregon distribution center and headquarters.</span><a className='fn-return_link' href='#fn1'><CornerRightUp size={16} /></a>
                            </li>
                        </ol>
                    </div>
                </div>
            </section>

            

        </ImpactReportLayout>
    );
}
